import {
  BailHearingDecision,
  BailRight,
  BailRightFeedback,
  DoubtfulCase,
} from "types";
import apiClient from "../lib/apiClients";
// --- DOUBTFUL CASES SERVICES ---
// (All imports must be at the top of the file)
// ...existing code...
export const fetchInstructions = async () => {
  const response = await apiClient.get("/Doubtful_Cases/instructions/");
  return response.data;
};
export const fetchInstructionsByCRNumberAndIncidentRegNo = async (
  crime_reference_number: string,
  incident_registration_number: string
) => {
  const response = await apiClient.get(
    `/Doubtful_Cases/instructions/?crime_registration_number=${crime_reference_number}&incident_registration_number=${incident_registration_number}`
  );
  return response.data;
};
export const fetchInstructionById = async (id: string | number) => {
  const response = await apiClient.get(`/Doubtful_Cases/instructions/${id}/`);
  return response.data;
};
export const addInstruction = async (data: DoubtfulCase) => {
  const response = await apiClient.post("/Doubtful_Cases/instructions/", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
export const editInstruction = async (data: any) => {
  const response = await apiClient.patch(
    `/Doubtful_Cases/instructions/${data?.id}/`,
    data
  );
  return response.data;
};
export const editInstruction2 = async (data: any) => {
  const response = await apiClient.patch(
    `/Doubtful_Cases/instructions/${data?.id}/`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const deleteInstruction = async (id: string | number) => {
  const response = await apiClient.delete(
    `/Doubtful_Cases/instructions/${id}/`
  );
  return response.data;
};

// Doubtful Cases - Asking Team Members
export const fetchAskingTeamMembers = async () => {
  const response = await apiClient.get("/Doubtful_Cases/asking-team-members/");
  return response.data;
};
export const addAskingTeamMember = async (data: any) => {
  const response = await apiClient.post(
    "/Doubtful_Cases/asking-team-members/",
    data
  );
  return response.data;
};
export const editAskingTeamMember = async (data: any) => {
  const response = await apiClient.patch(
    `/Doubtful_Cases/asking-team-members/${data?.id}/`,
    data
  );
  return response.data;
};
export const deleteAskingTeamMember = async (id: string | number) => {
  const response = await apiClient.delete(
    `/Doubtful_Cases/asking-team-members/${id}/`
  );
  return response.data;
};

// Doubtful Cases - Giving Team Members
export const fetchGivingTeamMembers = async () => {
  const response = await apiClient.get("/Doubtful_Cases/giving-team-members/");
  return response.data;
};
export const addGivingTeamMember = async (data: any) => {
  const response = await apiClient.post(
    "/Doubtful_Cases/giving-team-members/",
    data
  );
  return response.data;
};
export const editGivingTeamMember = async (data: any) => {
  const response = await apiClient.patch(
    `/Doubtful_Cases/giving-team-members/${data?.id}/`,
    data
  );
  return response.data;
};
export const deleteGivingTeamMember = async (id: string | number) => {
  const response = await apiClient.delete(
    `/Doubtful_Cases/giving-team-members/${id}/`
  );
  return response.data;
};

// Doubtful Cases - Instruction Feedbacks
export const fetchInstructionFeedbacks = async () => {
  const response = await apiClient.get(
    "/Doubtful_Cases/instruction-feedbacks/"
  );
  return response.data;
};
export const addInstructionFeedback = async (data: any) => {
  const response = await apiClient.post(
    "/Doubtful_Cases/instruction-feedbacks/",
    data
  );
  return response.data;
};
export const editInstructionFeedback = async (
  id: string | number,
  data: any
) => {
  const response = await apiClient.patch(
    `/Doubtful_Cases/instruction-feedbacks/${id}/`,
    data
  );
  return response.data;
};
export const deleteInstructionFeedback = async (id: string | number) => {
  const response = await apiClient.delete(
    `/Doubtful_Cases/instruction-feedbacks/${id}/`
  );
  return response.data;
};

// BailRight
export const fetchBailRight = async () => {
  const response = await apiClient.get<BailRight[]>("/bail_right/bail-rights/");
  return response.data;
};
export const fetchBailRightById = async (id: string) => {
  const response = await apiClient.get<BailRight>(
    "/bail_right/bail-rights/" + id + "/"
  );
  return response.data;
};
export const addBailRight = async (data: BailRight) => {
  const response = await apiClient.post("/bail_right/bail-rights/", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
export const editBailRight = async (data: any) => {
  const response = await apiClient.patch(
    "/bail_right/bail-rights/" + data?.uu_id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const editBailRight2 = async (data: any) => {
  const response = await apiClient.patch(
    "/bail_right/bail-rights/" + data?.uu_id + "/",
    data
  );
  return response.data;
};
export const deleteBailRight = async (reporter: BailRight) => {
  const response = await apiClient.delete(
    "/bail_right/bail-rights/" + reporter?.uu_id + "/"
  );
  return response.data;
};

//BailRightFeedback
export const addBailRightFeedback = async (data: BailRightFeedback) => {
  const response = await apiClient.post(
    "/bail_right/bail-coordinator-feedbacks/",
    data
  );
  return response.data;
};

// BailHearingDecision
export const fetchBailHearingDecision = async () => {
  const response = await apiClient.get<BailHearingDecision[]>(
    "/bail_right/bail-hearing-decisions/"
  );
  return response.data;
};
export const fetchBailHearingDecisionByBailRightId = async (id: number) => {
  const response = await apiClient.get<BailHearingDecision[]>(
    "/bail_right/bail-hearing-decisions/by-bail-right/" + id + "/"
  );
  return response.data;
};
export const addBailHearingDecision = async (data: BailHearingDecision) => {
  const response = await apiClient.post(
    "/bail_right/bail-hearing-decisions/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const editBailHearingDecision = async (data: any) => {
  const response = await apiClient.patch(
    "/bail_right/bail-hearing-decisions/" + data?.uu_id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const editBailHearingDecision2 = async (data: any) => {
  const response = await apiClient.patch(
    "/bail_right/bail-hearing-decisions/" + data?.uu_id + "/",
    data
  );
  return response.data;
};
export const deleteBailHearingDecision = async (
  reporter: BailHearingDecision
) => {
  const response = await apiClient.delete(
    "/bail_right/bail-hearing-decisions/" + reporter?.uu_id + "/"
  );
  return response.data;
};
